import { render, staticRenderFns } from "./census-data.vue?vue&type=template&id=e6bfffc4"
import script from "./census-data.vue?vue&type=script&lang=ts"
export * from "./census-data.vue?vue&type=script&lang=ts"
import style0 from "./census-data.vue?vue&type=style&index=0&id=e6bfffc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports